import { Injectable } from '@angular/core';
import { AuthenticationResult} from '@azure/msal-browser';
import { environment } from '../../../environments/environment';
import { useAuth } from './authConfig';

@Injectable({
  providedIn: 'root',
})
export class AuthService { 

  readonly authConfig = useAuth();

  constructor() {
    this.authConfig.msalInstance.initialize();
  }

  public async msalInitialise(){
    await this.authConfig.msalInstance
        .handleRedirectPromise()
        .then(async (authResult: AuthenticationResult | null) => {
          const accounts = this.authConfig.msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            this.authConfig.account = accounts[0];
  
            const response =
              await this.authConfig.msalInstance.acquireTokenSilent({
                account: this.authConfig.account,
                scopes: [environment.scopes],
              });
  
            this.authConfig.token = (await response).accessToken;
          }
        });
    
  }

  public userIsAuthenticated() {
    return this.authConfig
  }
}
